import TextArea from './TextArea';
import * as TextAreaStyles from './TextArea.styles';

export default TextArea;

export { TextAreaStyles };
